import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { DARK_CONTAINER_FIELDS_FLOATING, DARK_SECONDARY_BUTTONBACKGROUND } = COLORS;

export const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      maxWidth: 1129,
      height: 'auto',
      background: DARK_CONTAINER_FIELDS_FLOATING,
      borderRadius: 8,
      padding: '10px 30px 30px',
      paddingTop: 50,
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      position: 'relative',
      borderBottom: 'none',
      alignItems: 'center',
      margin: '10px 0 20px',

      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        paddingBottom: 10,
        textAlign: 'center',
        borderBottom: 'none',
      },

      '&::before': {
        content: '""',
        background: 'none',
        height: '1px',
        position: 'absolute',
        width: '50px',
        bottom: '-1px',
        [theme.breakpoints.down('md')]: {
          background: 'none',
        },
      },
    },
    stepperContainer: {
      [theme.breakpoints.down('md')]: {
        marginTop: 15,
      },
    },
    body: {
      minHeight: 500,
      display: 'flex',
      flexDirection: 'column',
      height: 'auto',
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.down(692)]: {
        minHeight: 'unset',
      },
    },
    onlyBody: {
      height: 775,
    },

    buttonCls: {
      height: '60px !important',
      borderRadius: 8,
      textTransform: 'unset',
      textDecoration: 'none!important',
      maxWidth: 335,
      fontSize: 16,
    },
    backIconButton: {
      height: 60,
      width: 60,
      position: 'absolute',
      left: 0,
      borderRadius: '50%',
      [theme.breakpoints.down(692)]: {
        position: 'unset',
        marginTop: 10,
        backgroundColor: DARK_SECONDARY_BUTTONBACKGROUND,
        width: 335,
        borderRadius: 8,
        color: 'white',
        fontSize: 16,
      },
    },
    footer: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'row',
      width: '100%',
      [theme.breakpoints.down(692)]: {
        flexDirection: 'column-reverse',
      },
    },
  }),
);
